const $ = jQuery.noConflict();

const LoginUser = {

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		this.login();
	},

	login: function() {
		$('.js-login-btn').click(()=>{
			const username = $('.js-username').val();

			if (username === '') {
				$('.js-username-error').text('This field is required!');
			} if (username) {
				$('.js-username-error').empty();
			}
			const password = $('.js-password').val();

			if (password === '') {
				$('.js-password-error').text('This field is required!');
			} if (password) {
				$('.js-password-error').empty();
			}
			if (username && password) {
				$.ajax({
					type: 'POST',
					// eslint-disable-next-line no-undef
					url: fwsLocalized.ajaxUrl,
					data: {
						action: 'LoginUser',
						username: username,
						password: password
					},
					success: function() {
						location.reload();
					}
				});
			}
		});
	}
};

export default LoginUser;
